import { render, staticRenderFns } from "./CallOut.vue?vue&type=template&id=2fa0a06e&scoped=true"
import script from "./CallOut.vue?vue&type=script&lang=js"
export * from "./CallOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0a06e",
  null
  
)

export default component.exports